import React, { useState, useEffect } from 'react';

interface AnimatedDigitProps {
  digits: number[];
  direction: 'up' | 'down';
}

const AnimatedDigit: React.FC<AnimatedDigitProps> = ({ digits, direction }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const totalDigits = digits.length;
  const duration = 0.8;
  const stepDuration = duration / (totalDigits - 1);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex < totalDigits - 1 ? prevIndex + 1 : prevIndex
      );
    }, stepDuration * 500);

    return () => clearInterval(interval);
  }, [totalDigits, stepDuration]);

  return (
    <div className="w-[18px] h-8 relative overflow-hidden text-[28px]">
      {digits.map((digit, index) => (
        <span
          key={index}
          className={`absolute top-0 left-0 transition-transform`}
          style={{
            transform: `translateY(${(index - currentIndex) * (direction === 'up' ? 100 : -100)}%)`,
            transition: 'transform 0.3s cubic-bezier(0.68, 0, 0.32, 1)',
          }}
        >
          {digit}
        </span>
      ))}
    </div>
  );
};

export default AnimatedDigit;
